module.exports = __webpack_public_path__ + "kiribati.svg?8f96004c6008392ad8ad028306c4be40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kiribati.svg
// module id = 205
// module chunks = 10